// Texty toolbaru výpisu a mobilního stránkování (listingTools.js).
export default {
  defaultSort: 'Doporučujeme',
  /** „1–12 z 350" (rozsah produktů v toolbaru) */
  range: (start, end, total) => start + '–' + end + ' z ' + total,
  /** „Strana 3 z 30" */
  page: (from, pages) => 'Strana ' + from + ' z ' + pages,
  /** „Strany 1–2 z 30" (loadMore dosype další stranu) */
  pages: (from, to, pages) => 'Strany ' + from + '–' + to + ' z ' + pages,
  prevPage: 'Předchozí strana',
  nextPage: 'Další strana',
};
